import IntegrationsPage from 'client/modules/Integrations/pages/IntegrationsPage';
import AccountSettingsPage from 'client/modules/Settings/pages/AccountSettingsPage/AccountSettingsPage';
import SessionsPage from 'client/modules/Settings/pages/AccountSettingsPage/SessionsPage';
import ApiKeysPage from 'client/modules/Settings/pages/ApiKeysPage/ApiKeysPage';
import OAuthConsentPage from 'client/modules/Settings/pages/OAuthConsentPage/OAuthConsentPage';
import BillingPage from 'client/modules/Settings/pages/BillingPage/BillingPage';
import ChangePlanPage from 'client/modules/Settings/pages/BillingPage/ChangePlanPage';
import GeneralPage from 'client/modules/Settings/pages/GeneralPage/GeneralPage';
import IntegrationConfigGSheets from 'client/modules/Settings/pages/IntegrationsPage/components/IntegrationConfigGSheets';
import IntegrationConfigHubspot from 'client/modules/Settings/pages/IntegrationsPage/components/IntegrationConfigHubspot';
import IntegrationConfigSalesforce from 'client/modules/Settings/pages/IntegrationsPage/components/IntegrationConfigSalesforce';
import IntegrationConfigSlack from 'client/modules/Settings/pages/IntegrationsPage/components/IntegrationConfigSlack';
import IntegrationConfigWebhooks from 'client/modules/Settings/pages/IntegrationsPage/components/IntegrationConfigWebhooks';
import IntegrationConfigZendesk from 'client/modules/Settings/pages/IntegrationsPage/components/IntegrationConfigZendesk';
import IntegrationPage from 'client/modules/Settings/pages/IntegrationsPage/IntegrationPage';
import IntegrationsListPage from 'client/modules/Settings/pages/IntegrationsPage/IntegrationsListPage';
import MailProviderPageContainer from 'client/modules/Settings/pages/MailProviderPage/MailProviderPageContainer';
import SignInSecurityPage from 'client/modules/Settings/pages/SignInSecurityPage/SignInSecurityPage';
import TeamPage from 'client/modules/Settings/pages/TeamPage/TeamPage';
import DeleteRespondentsPage from 'client/modules/Settings/pages/DeleteRespondentsPage';
import AuditLogPage from 'client/modules/Settings/pages/AuditLogPage';
import AdditionalQuestions from 'client/modules/Surveys/pages/CustomizeSurvey/AdditionalQuestions';
import CustomizeEmail from 'client/modules/Surveys/pages/CustomizeSurvey/CustomizeEmail';
import CustomizeFollowup from 'client/modules/Surveys/pages/CustomizeSurvey/CustomizeFollowup';
import CustomizeSMS from 'client/modules/Surveys/pages/CustomizeSurvey/CustomizeSMS';
import CustomizeThankyou from 'client/modules/Surveys/pages/CustomizeSurvey/CustomizeThankyou';
import CustomizeTranslations from 'client/modules/Surveys/pages/CustomizeSurvey/CustomizeTranslations';
import Targeting from 'client/modules/Surveys/pages/CustomizeSurvey/Targeting';
import TargetingAudiences from 'client/modules/Surveys/pages/CustomizeSurvey/TargetingAudiences';
import TargetingResponseSettings from 'client/modules/Surveys/pages/CustomizeSurvey/TargetingResponseSettings';
import TargetingScheduling from 'client/modules/Surveys/pages/CustomizeSurvey/TargetingScheduling';
import TargetingWeb from 'client/modules/Surveys/pages/CustomizeSurvey/TargetingWeb';
import LinkPage from 'client/modules/Surveys/pages/LinkPage/LinkPage';
import ManageTagsPage from 'client/modules/Surveys/pages/ManageTagsPage';
import SharePage from 'client/modules/Surveys/pages/SharePage/SharePage';
import SurveyPeopleContainer from 'client/modules/Surveys/pages/SurveyPeopleContainer';
import React from 'react';
import { Navigate, Route } from 'react-router';
import RequireFeature from './modules/App/components/FeatureGate/RequireFeature';
import Authenticated from './Authenticated';
import AnalyzeLayout from './modules/Analyze/AnalyzeLayout';
import AnalyzeOverTimePage from './modules/Analyze/pages/AnalyzeOverTimePage';
import AnalyzeDeliveryPage from './modules/Analyze/pages/AnalyzeDeliveryPage';
import AnalyzeSnapshotPage from './modules/Analyze/pages/AnalyzeSnapshotPage';
import AnalyzeBreakdownPage from './modules/Analyze/pages/AnalyzeBreakdownPage';
import AnalyzeFollowUpQuestionsPage from './modules/Analyze/pages/AnalyzeFollowUpQuestionsPage';
import LoggedRedirect from './modules/App/components/LoggedRedirect';
import SignInAsPage, { onSignInAsEnter } from './modules/Auth/pages/Login/SignInAsPage';
import VerifyEmailPage from './modules/Auth/pages/Login/VerifyEmailPage';
import VerifyEmailResendPage from './modules/Auth/pages/Login/VerifyEmailResendPage';
import PeopleList from './modules/People/pages/List/PeopleList';
import PersonView from './modules/People/pages/Person/PersonView';
import ResponsePageContainer from './modules/Response/pages/ResponsePage/ResponsePageContainer';
import SearchesList from './modules/Searches/List/SearchesList';
import EmailPreferencesSettings from './modules/Settings/pages/EmailPreferencesSettings';
import SettingsPage from './modules/Settings/pages/SettingsPage/SettingsPage';
import CheckoutOkPage, {
  validateSubscription,
} from './modules/Subscriptions/pages/CheckoutOkPage/CheckoutOkPageContainer';
import CheckoutErrorPage from './modules/Subscriptions/pages/CheckoutErrorPage/CheckoutErrorPageContainer';
import CheckoutPage, {
  ensurePlan,
} from './modules/Subscriptions/pages/CheckoutPage/CheckoutPageContainer';
import SubscriptionsPage, {
  redirect,
} from './modules/Subscriptions/pages/SubscriptionsPage/SubscriptionsPageContainer';
import OnEnter from './modules/Surveys/components/OnEnter/OnEnter';
import ChooseChannel from './modules/Surveys/pages/ChooseChannel/ChooseChannel';
import ChooseTypePage from './modules/Surveys/pages/ChooseTypePage/ChooseTypePage';
import CustomizeSurvey, {
  loadSurvey,
} from './modules/Surveys/pages/CustomizeSurvey/CustomizeSurveyContainer';
import DashboardPage, { loadSurveys } from './modules/Surveys/pages/DashboardPage/DashboardPage';
import ExportResultsPage from './modules/Surveys/pages/ExportResultsPage/ExportResultsPage';
import ImportPeople from './modules/Surveys/pages/ImportPeople/ImportPeople';
import ReviewImport from './modules/Surveys/pages/ReviewImport/ReviewImport';
import SurveysPage from './modules/Surveys/pages/SurveysPage/SurveysPage';
import WebSnippetPage from './modules/Surveys/pages/WebSnippetPage/WebSnippetPage';

// Take the regular authentication & redirect to login from before

function AuthenticatedRoutes(store) {
  return (
    // `handle.app` marks this entire authenticated dashboard subtree as
    // client-side rendered (CSR shell). The server's `shouldServerRender`
    // returns false when any matched route in the chain has `handle.app`, so
    // public / respondent / marketing routes keep SSR by default and a newly
    // added authenticated route can never accidentally regress that.
    <Route element={<Authenticated />} handle={{ app: true }}>
      <Route
        path="sign-in-as/:email"
        element={
          <OnEnter func={onSignInAsEnter}>
            <SignInAsPage />
          </OnEnter>
        }
      />
      <Route path="verify-email" element={<VerifyEmailPage />} />
      <Route path="verify-email-resend" element={<VerifyEmailResendPage />} />
      <Route path="oauth/consent" element={<OAuthConsentPage />} />
      <Route path="logged-redirect" element={<LoggedRedirect />} />
      <Route
        path="surveys/new-choose-type"
        element={
          <OnEnter func={loadSurveys}>
            <ChooseTypePage />
          </OnEnter>
        }
      />
      <Route
        path="surveys/new"
        element={
          <OnEnter func={loadSurveys}>
            <CustomizeSurvey />
          </OnEnter>
        }
      />
      <Route
        path="surveys/:id"
        element={
          <OnEnter func={loadSurveys}>
            <DashboardPage />
          </OnEnter>
        }
      />
      <Route
        path="surveys/:id/saved-searches/:savedSearchId"
        element={
          <OnEnter func={loadSurveys}>
            <DashboardPage />
          </OnEnter>
        }
      />
      <Route
        path="surveys/:id/tags"
        element={
          <RequireFeature feature="autoTagging">
            <ManageTagsPage />
          </RequireFeature>
        }
        loader={ManageTagsPage.loader(store)}
      />
      <Route
        path="surveys/:id/edit/*"
        element={
          <OnEnter func={loadSurvey}>
            <CustomizeSurvey />
          </OnEnter>
        }
      >
        <Route index element={<Navigate to="email" replace />} />
        <Route path="email" element={<CustomizeEmail />} />
        <Route
          path="followup"
          element={
            <RequireFeature feature="dynamicFollowup">
              <CustomizeFollowup />
            </RequireFeature>
          }
        />
        <Route
          path="sms"
          element={
            <RequireFeature feature="sms">
              <CustomizeSMS />
            </RequireFeature>
          }
        />
        <Route path="thankyou" element={<CustomizeThankyou />} />
        <Route
          path="questions"
          element={
            <RequireFeature feature="additionalQuestions">
              <AdditionalQuestions />
            </RequireFeature>
          }
        />
        <Route path="targeting/*" element={<Targeting />}>
          <Route index element={<Navigate to="scheduling" replace />} />
          <Route path="scheduling" element={<TargetingScheduling />} />
          <Route
            path="web"
            element={
              <RequireFeature feature="webTargeting">
                <TargetingWeb />
              </RequireFeature>
            }
          />
          <Route
            path="audiences"
            element={
              <RequireFeature feature="audiences">
                <TargetingAudiences />
              </RequireFeature>
            }
          />
          <Route path="response-settings" element={<TargetingResponseSettings />} />
        </Route>
        <Route path="translations" element={<CustomizeTranslations />} />
      </Route>
      <Route
        path="surveys/:id/searches"
        element={
          <OnEnter func={loadSurvey}>
            <SearchesList />
          </OnEnter>
        }
      />
      <Route
        path="surveys/:id/people"
        element={
          <OnEnter func={loadSurvey}>
            <PeopleList />
          </OnEnter>
        }
      />
      <Route
        path="surveys/:id/people/:personId"
        element={
          <OnEnter func={loadSurvey}>
            <PersonView />
          </OnEnter>
        }
      />
      <Route
        path="surveys/:id/analyze"
        element={<AnalyzeLayout />}
        loader={AnalyzeLayout.loader(store)}
      >
        <Route index element={<AnalyzeOverTimePage />} />
        <Route path="delivery" element={<AnalyzeDeliveryPage />} />
        <Route path="snapshot" element={<AnalyzeSnapshotPage />} />
        <Route path="breakdown" element={<AnalyzeBreakdownPage />} />
        <Route path="questions" element={<AnalyzeFollowUpQuestionsPage />} />
      </Route>
      <Route
        path="surveys/:id/export"
        element={
          <OnEnter func={loadSurvey}>
            <ExportResultsPage />
          </OnEnter>
        }
      />
      <Route
        path="surveys/:id/import/*"
        element={
          <OnEnter func={loadSurvey}>
            <SurveyPeopleContainer />
          </OnEnter>
        }
      >
        <Route index element={<ChooseChannel />} />
        <Route path="web" element={<WebSnippetPage />} />
        <Route path="share" element={<SharePage />} />
        <Route path="share/:link" element={<LinkPage />} />
        <Route path=":channel" element={<ImportPeople />} />
        <Route path=":channel/:importId" element={<ReviewImport />} />
      </Route>
      <Route path="surveys/:surveyId/responses/:responseId" element={<ResponsePageContainer />} />
      <Route
        path="surveys"
        element={
          <OnEnter func={loadSurveys}>
            <SurveysPage />
          </OnEnter>
        }
      />
      <Route
        path="surveys/list/:folder?"
        element={
          <OnEnter func={loadSurveys}>
            <SurveysPage />
          </OnEnter>
        }
      />
      <Route path="settings" element={<Navigate replace to="/settings/general" />} />
      <Route path="settings/billing/change-plan" element={<ChangePlanPage />} />
      <Route path="settings/*" loader={SettingsPage.loader(store)} element={<SettingsPage />}>
        <Route path="general" element={<GeneralPage />} />
        <Route path="team" element={<TeamPage />} />
        <Route
          path="sso"
          element={
            <RequireFeature feature="sso">
              <SignInSecurityPage />
            </RequireFeature>
          }
        />
        <Route
          path="developer"
          element={
            <RequireFeature feature="api">
              <ApiKeysPage />
            </RequireFeature>
          }
        />
        <Route path="mail" element={<MailProviderPageContainer />} />
        <Route path="integrations/*">
          <Route
            path=""
            element={
              <RequireFeature feature="integrations">
                <IntegrationsListPage />
              </RequireFeature>
            }
          />
          <Route
            path="*"
            element={
              <RequireFeature feature="integrations">
                <IntegrationPage />
              </RequireFeature>
            }
          >
            <Route path="gsheets" element={<IntegrationConfigGSheets />} />
            <Route path="hubspot" element={<IntegrationConfigHubspot />} />
            <Route path="salesforce" element={<IntegrationConfigSalesforce />} />
            <Route path="slack" element={<IntegrationConfigSlack />} />
            <Route path="webhooks" element={<IntegrationConfigWebhooks />} />
            <Route path="zendesk" element={<IntegrationConfigZendesk />} />
          </Route>
        </Route>
        <Route path="profile" element={<AccountSettingsPage />} />
        <Route path="email-preferences" element={<EmailPreferencesSettings />} />
        <Route path="sessions" element={<SessionsPage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route
          path="audit-log"
          element={
            <RequireFeature feature="auditLog">
              <AuditLogPage />
            </RequireFeature>
          }
        />
        <Route path="delete-respondents" element={<DeleteRespondentsPage />} />
        <Route path="" element={<Navigate to="general" replace />} />
      </Route>
      <Route path="account" element={<Navigate replace to="/settings/profile" />} />
      <Route path="account/*" element={<Navigate replace to="/settings/profile" />} />
      <Route
        path="email-preferences"
        element={<Navigate replace to="/settings/email-preferences" />}
      />
      <Route
        path="subscriptions"
        element={
          <OnEnter func={redirect}>
            <SubscriptionsPage />
          </OnEnter>
        }
      />
      <Route
        path="subscriptions/checkout"
        element={
          <OnEnter func={ensurePlan}>
            <CheckoutPage />
          </OnEnter>
        }
      />
      <Route
        path="subscriptions/ok"
        element={
          <OnEnter func={validateSubscription}>
            <CheckoutOkPage />
          </OnEnter>
        }
      />
      <Route path="subscriptions/error" element={<CheckoutErrorPage />} />
      <Route
        path="integrations/:type/add"
        element={
          <RequireFeature feature="integrations">
            <IntegrationsPage />
          </RequireFeature>
        }
      />
    </Route>
  );
}

export default AuthenticatedRoutes;
